import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
import { useIsOrgAdmin } from '#pplx/frontend/apps/ask/organization/hooks/useIsOrgAdmin.js';
import { useOrgSkillEntitlementMode } from '#pplx/frontend/apps/ask/organization/hooks/useOrgSkillEntitlementMode.js';
export const ORG_SKILL_MANAGEMENT_PERMISSION_ID = 'org_skills_configure';
// The single FE predicate for org-skill management authority, mirroring
// skillservice's verifyOrgSkillManagementWrite: until the org's
// `org-skill-entitlement-mode` flag is explicitly `enforce`, the backend
// requires the legacy org-admin role; in `enforce` the `org_skills_configure`
// permission decides. Every management surface (page route, sidebar/search
// gate, upload CTA, custom-skills toggle, per-skill actions) must derive from
// this hook so UI visibility cannot drift from what the backend allows.
// Org plugin surfaces derive from useCanManageOrgPlugins instead, which reads
// org_skills_configure without the entitlement-mode or org-admin arms.
export function useCanManageOrgSkills(reason) {
    const isOrgAdmin = useIsOrgAdmin();
    const { mode, loading: modeLoading } = useOrgSkillEntitlementMode();
    const isEnforce = mode === 'enforce';
    // Effective permissions only decide in enforce mode, so don't pay for the
    // fetch outside it.
    const { permissions, isLoading: permissionsLoading } = useEffectivePermissions({
        reason,
        enabled: isEnforce,
    });
    return {
        canManageOrgSkills: isEnforce
            ? permissions.has(ORG_SKILL_MANAGEMENT_PERMISSION_ID)
            : isOrgAdmin,
        loading: modeLoading || (isEnforce && permissionsLoading),
    };
}
//# sourceMappingURL=useCanManageOrgSkills.js.map